module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Leave every slot selected to sell the whole event. Narrow it to sell a shorter ticket - the first evenings of a course, say - as its own variant.":"Alles ausgewählt lassen, um die ganze Veranstaltung zu verkaufen. Eingrenzen, um ein kürzeres Ticket - etwa die ersten Abende eines Kurses - als eigene Variante zu verkaufen."}}')
  delete Component.options._Ctor
}
